import VueRouter from 'vue-router'
import Vue from 'vue'

import buy from '../components/view/buy_n1'
import buy2 from '../components/view/buy_new'
import download from '../components/view/download'
// import featurepack from '../components/view/featurepack_new'
import about from '../components/view/about'
import home from '../components/view/home'
import service from '../components/view/service'
import plantform from '../components/view/plantform_new'
import gardenfirst from '../components/view/gardenfirst'
import garden from '../components/view/garden'
import news from '../components/view/news'
import dict from '../components/view/dict'
import anli from '../components/view/anli'
import shengjishuoming from '../components/view/shengjishuoming'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes=[
  // {
  //   path:"/buy2",
  //   component:buy2,
  //   name:"buy2"
  // },
  {
    path:"/home",
    component:home,
    name:"home",
    
  },
  {
    path:"/dict",
    component:dict,
    name:"dict",
    
  },
  {
    path:"/gardenfirst",
    component:gardenfirst,
    name:"gardenfirst",
    
  },
  {
    path:"/garden",
    component:garden,
    name:"garden",
    
  },
  {
    path:"/buy",
    component:buy2,
    name:"buy"
  },
  {
    path:"/download",
    component:download,
    name:"download"
  },
  {
    path:"/news",
    component:news,
    name:"news"
  },
 
  {
    path:"/service",
    component:service,
    name:"service"
  },
  {
    path:"/shengjishuoming",
    component:shengjishuoming,
    name:"shengjishuoming"
  },
  // {
  //   path:"/featurepack/:id",
  //   component:featurepack,
  //   name:"featurepack"
  // },
  {
    path:"/about",
    component:about,
    name:"about"
  },
  {
    path:"/anli/:id",
    component:anli,
    name:"anli"
  },
  {
    path:"/plantform/:id",
    component:plantform,
    name:"plantform"
  },
  {path: '*', redirect: '/home'}


]

const router = new VueRouter({
  mode: 'hash',   
 
    routes
  })
export default router